module.exports = __webpack_public_path__ + "img/pensil.b3c685e7.svg";